import { createAiPromptRequest } from '../../../../ai-insights/aiInsightsTypes';
import { transactionActionExecutionProfiles } from '../../executionProfiles';
import type { TransactionActionRunnerOutput } from '../../proposalTypes';
import type { TransactionActionRunner } from '../../runners';
import { recategorizePrompt } from './prompt';

const RECATEGORIZE_AGENT_ID = 'ai-insights-v2';

export const recategorizeStructuredModelRunner: TransactionActionRunner = {
  id: 'structured_model',
  buildOutput({ batch }): TransactionActionRunnerOutput {
    if (batch.capability !== 'recategorize' || batch.eligibleTransactions.length === 0) {
      return null;
    }

    const profile = transactionActionExecutionProfiles.recategorize;

    // Each eligible transaction carries its own allowedCategories reference (see types.ts) so
    // the validator - which only receives eligibleTransactions, not the whole batch - has
    // everything it needs. Don't send that same list once per transaction over the wire though;
    // strip it back out here and send it once, alongside a slimmer per-transaction payload.
    const transactions = batch.eligibleTransactions.map(
      ({ transactionId, payee, date, amount, currentCategoryName }) => ({
        transactionId,
        payee,
        date,
        amount,
        currentCategoryName,
      }),
    );

    return {
      transport: 'structured_model',
      request: createAiPromptRequest({
        userPrompt: { text: recategorizePrompt.prompt },
        agent: RECATEGORIZE_AGENT_ID,
        context: {
          text: recategorizePrompt.contextPrefix,
          data: { transactions, allowedCategories: batch.allowedCategories },
        },
        outputSchema: recategorizePrompt.schema.schema,
        options: {
          model: profile.model,
          temperature: profile.temperature,
          maxOutputTokens: profile.maxOutputTokens,
        },
      }),
    };
  },
};
